import { LocaleCommon } from '../en/common'

// includes new-match, notify, external, not-found
const common: LocaleCommon = {
  addMatches: 'Añadir Partidos',
  editMatch: 'Editar Partidos',
  deleteMatch: 'Eliminar Partidos',
  oldPass: 'Contraseña antigua',
  newPass: 'Contraseña nueva',
  confirmPass: 'Confirmar Contraseña',
  save: 'Guardar',
  firstName: 'Nombre',
  lastName: 'Apellido',
  location: 'Ubicación',
  yourBirthday: 'Tu Cumpleaños',
  birthday: 'Cumpleaños',
  birthDateMin: 'Para crear una cuenta para un usuario menor de 13 años, complete el formulario a continuación:',
  under13AccountCreationForm: 'Formulario de solicitud de creación de cuenta',
  gender: 'Género',
  phone: 'Teléfono',
  yourPhone: 'Tú Teléfono',
  congrats: '¡Felicidades!',
  error: 'Error',
  search: 'Buscar',
  filters: 'Filtros',
  apply: 'Aplicar',
  clearAll: 'Limpiar Todo',
  distance: 'Distancia',
  noLimit: 'Sin límite',
  man: 'Hombre',
  woman: 'Mujer',
  anybody: 'Cualquiera',
  men: 'Hombres',
  women: 'Mujeres',
  type: 'Tipo',
  doubles: 'Dobles',
  singles: 'Individuales',
  Doubles: 'Dobles',
  Singles: 'Individuales',
  Any: 'Cualquiera',
  duprRating: 'Clasificación DUPR',
  ageRange: 'Rango de Edad',
  minAge: 'Edad Mínima',
  maxAge: 'Edad Máxima',
  under19: 'Menores de 19',
  share: 'Compartir',
  message: 'Mensaje',
  messages: 'Mensajes',
  email: 'Email',
  emailPlaceHolder: 'Escribe tu Email',
  confirmEmail: 'Confirmar Email',
  confirmEmailPlaceHolder: 'Confirme su Email',
  password: 'Contraseña',
  passwordPlaceHolder: 'Escribe Contraseña',
  confirmPassword: 'Confirmar Contraseña',
  confirmPasswordPlaceHolder: 'Confirmar Contraseña',
  fullName: 'Nombre Completo',
  fullNamePlaceHolder: 'Escriba Nombre Completo',
  birthDate: 'Fecha de Nacimiento',
  birthDatePlaceHolder: 'Seleccionar Fecha de Nacimiento',
  phonePlaceHolder: 'Escriba su Teléfono',
  continue: 'Continuar',
  selectCountry: 'Seleccionar País',
  submit: 'Enviar',
  forgotPassword: '¿Olvidaste tu Contraseña?',
  cancel: 'Cancelar',
  textDigitCode: 'Escriba su Código de 4 Dígitos',
  resend: 'Reenviar',
  verify: 'Verificar',
  noMoreResults: 'Sin más resultados.',
  contactSupport: 'Contactar Atención al Cliente',
  viewAll: 'Ver Todo',
  payments: 'Pagos',
  setUpPayments: 'Configurar Pagos',
  details: 'Detalles',
  navigate: 'Navegar',
  member: 'Miembro',
  members: 'Miembros',
  exportCSV: 'Exportar CSV',
  exportFailed: 'No pudimos exportar tus miembros. Inténtalo de nuevo.',
  exportTimedOut: 'La exportación está tardando más de lo esperado. Inténtalo de nuevo en unos minutos.',
  exportConnectionLost: 'Perdimos la conexión mientras preparábamos tu exportación. Inténtalo de nuevo.',
  downloadCSVDesc: 'Descarga nuestra plantilla CSV para invitar masivamente utilizando emails.',
  downloadCSVNote: 'NOTA: Debes eliminar el encabezado del archivo CSV',
  learnMore: 'Más Información',
  downloadTemplate: 'Descargar Plantilla',
  dragFile: 'Arrastra tu archivo CSV aquí o',
  browseFile: 'Examinar Archivos',
  removeFile: 'Eliminar archivo',
  matches: 'Partidos',
  match: 'Partido',
  sort: 'Ordenar',
  newToOld: 'Más Reciente a Más Antiguo',
  oldToNew: 'Más Antiguo a Más Reciente',
  clearFilters: 'Limpiar Filtros',
  matchId: 'Identificativo',
  reUpload: 'Volver a Subir',
  events: 'Eventos',
  deleteEvent: 'Eliminar Evento',
  deleteEventDesc: 'Eliminar este evento también eliminará los cuadros asociados. Confirma para eliminar este evento.',
  confirm: 'Confirmar',
  delete: 'Eliminar',
  registeredPlayers: 'Jugadores Registrados',
  upcoming: 'Próximos',
  draft: 'Draft',
  open: 'Abrir',
  ongoing: 'En Curso',
  completed: 'Completado',
  logo: 'Logo',
  eventLogo: 'Logo del Evento',
  eventName: 'Nombre del Evento',
  registration_url: 'Dirección URL de registro',
  summary: 'Resumen',
  whatAreTheDetails: '¿Cuáles son los detalles?',
  entryFee: 'Tarifa de Inscripción',
  entryFeeDesc:
    'Los jugadores pagarán esta tarifa de inscripción además de la tarifa del cuadro. Puedes establecer el precio por soporte más tarde.',
  memberPrice: 'Precio para Miembros',
  nonMemberPrice: 'Precio para No Miembros',
  policies: 'Políticas',
  uploadWaiver: 'Subir Exención',
  uploadWaiverDesc: 'DUPR recomienda incluir una Exención de responsabilidad en los eventos.',
  liabilityWaiver: 'Exención de responsabilidad',
  refundPolicy: 'Política de Reembolso',
  refundPolicyDesc:
    '¿Recibirán los registrantes un reembolso completo o parcial si cancelan antes de que comience el evento? ¿Recibirán un reembolso parcial si cancelan después de que la liga haya comenzado?',
  healthPolicy: 'Política de Salud',
  healthPolicyDesc: '¿Tendrá tu liga reglas específicas sobre la salud y seguridad de los participantes?',
  bracket: 'Soporte',
  brackets: 'Soportes',
  addBracket: 'Añadir Soporte',
  select: 'Seleccionar',
  playerGroup: 'Grupo de Jugadores',
  format: 'Formato',
  ratingRange: 'Intervalo de clasificación',
  minimum: 'Mínima',
  maximum: 'Máxima',
  name: 'Nombre',
  bracketName: 'Nombre del Cuadro',
  autoGenerate: 'Generar Automáticamente',
  courts: 'Canchas',
  courtsDesc: 'Número de Canchas (Mínimo 1 y Máximo 8)',
  maxTeams: 'Máx Equipos',
  maxTeamsDec: '¿Cuántos equipos participarán en el evento?',
  waitList: 'Lista de Espera',
  waitListDesc: '¿Cuántos equipos te gustaría permitir que se unan a la lista de espera?',
  registration: 'Registro',
  registrationDesc: 'Establecer la duración para que los jugadores puedan registrarse',
  startDateTime: 'Fecha y Hora de Inicio',
  endDateTime: 'Fecha y Hora de Fin',
  competition: 'Competición',
  competitionDesc: 'Establecer la fecha y hora para la competición de este soporte',
  timeZone: 'Zona Horaria',
  price: 'Precio',
  priceDesc: 'Los jugadores pagarán esto además de la tarifa de inscripción',
  selectAnImage: 'Seleccionar una imagen para cargar',
  loadingImage: 'Cargando imagen...',
  chooseFile: 'Elegir Archivo',
  invite: 'Invitar',
  optional: '(Opcional)',
  messageAndDataRatesMayApply: 'Pueden aplicarse tarifas por mensaje y datos.',
  sendInvite: 'Enviar Invitación',
  invites: 'Invitaciones',
  requests: 'Solicitudes',
  invited: 'Invitado',
  ignoreAll: 'Ignorar Todo',
  acceptAll: 'Aceptar Todo',
  ignore: 'Ignorar',
  cancelInvite: 'Cancelar Invitación',
  address: 'Dirección',
  addNew: 'Agregar Nueva',
  mi: 'Mi',
  startsIn: 'Comienza en',
  endsIn: 'Termina en',
  downloadLiabilityWaiver: 'Descargar Renuncia de Responsabilidad',
  healthSafetyPolicy: 'Política de Salud y Seguridad',
  yes: 'Sí',
  no: 'No',
  addPartner: 'Añadir Compañero',
  addPartnerNote: 'También puedes esperar hasta después del registro para añadir un compañero',
  ok: 'Aceptar',
  success: 'Éxito',
  failure: 'Fracaso',
  signUpOrLogin: 'Inscríbete o Inicia Sesión para ver esta información',
  accept: 'Aceptar',
  goBack: 'Volver',
  with: 'con',
  game: 'Juego',
  highToLowRating: 'Clasificación de alta a baja',
  lowToHighRating: 'Clasificación de baja a alta',
  add: 'Añadir',
  confirmation: 'Confirmación',
  back: 'Atrás',
  next: 'Siguiente',
  saveChanges: ' Save Changes',
  sortingRules: 'Reglas de Clasificación',
  sortingRulesDesc:
    'Los equipos se ordenan por clasificación promedio. Las clasificaciones verificadas tienen más peso que las clasificaciones provisionales. Los jugadores con una clasificación NR se consideran clasificados como 2.00.',
  create: 'Crear',
  matchDate: 'Fecha del partido',
  time: 'Hora',
  connectWith: 'Conectar Con',
  externalLoginCheckbox:
    'Permitir a DUPR crear una nueva sesión para este sitio usando un acceso de solo lectura, todos mis datos estarán protegidos y seguros',
  logging: 'Iniciando Sesión...',
  login: 'Iniciar Sesión',
  saveMatch: 'Guardar Partida',
  submitMatches: 'Enviar Partidas',
  confirmSubmitMatches: 'Estas partidas se enviarán y las clasificaciones de los jugadores se actualizarán en breve.',
  event: 'Evento',
  eventPlaceHolder: 'Nombre del Evento',
  date: 'Fecha',
  checkboxAddYourSelf: '¿Añadirte como jugador en esta partida?',
  team1: 'Equipo 1',
  team2: 'Equipo 2',
  searchPlayer: 'Buscar jugador',
  score: 'Puntuación',
  standard: 'Estándar',
  rally: 'Rally',
  game1: 'Juego 1',
  game2: 'Juego 2',
  game3: 'Juego 3',
  game4: 'Juego 4',
  game5: 'Juego 5',
  addAnotherMatch: 'Añadir Otra Partida',
  oops: '¡Ups!',
  redirectedDashboard: 'Serás redirigido al Panel en',
  seconds: 'segundos',
  DUPRIDCopied: '¡DUPRID Copiado!',
  copyClipboard: 'Copiar al portapapeles',
  myAccount: 'Mi Cuenta',
  editProfile: 'Editar perfil',
  passwordSecurity: 'Contraseña y Seguridad',
  infoSupport: 'Información y Soporte',
  support: 'Soporte',
  runEvents: 'Eventos',
  FAQs: 'Preguntas Frecuentes',
  termsUse: 'Términos de Uso',
  privacyPolicy: 'Política de Privacidad',
  logout: 'Cerrar Sesión',
  warning: 'Aviso',
  reset: 'Restablecer',
  Members: 'Miembros',
  Matches: 'Partidos',
  Events: 'Eventos',
  Invites: 'Invitaciones',
  Queue: 'Cola',
  Standings: 'Clasificaciones',
  Players: 'Jugadores',
  Teams: 'Equipos',
  UnmatchedPlayer: 'Jugador inigualable',
  Payments: 'Pagos',
  performance: 'Rendimiento',
  myPerformance: 'Mi Rendimiento',
  newMatch: 'Nueva partida',
  players: 'Jugadores',
  clubs: 'Clubes',
  Week: 'Semana',
  Month: 'Mes',
  RoundRobin: 'Round Robin',
  Waterfall: 'Cascada',
  FlexLeague: 'Liga flexible',
  Mixed: 'Mezclado',
  Open: 'Abrir',
  Men: 'Hombres',
  Women: 'Mujeres',
  ViewAll: 'Ver Todo',
  Round: 'Ronda',
  Round1: 'Ronda 1',
  Round2: 'Ronda 2',
  Round3: 'Ronda 3',
  Round4: 'Ronda 4',
  Round5: 'Ronda 5',
  Round6: 'Ronda 6',
  Round7: 'Ronda 7',
  Round8: 'Ronda 8',
  Round9: 'Ronda 9',
  Round10: 'Ronda 10',
  Dashboard: 'Dashboard',
  SearchPlayer: 'Buscar jugador',
  SearchEvents: 'Buscar eventos',
  Rankings: 'Clasificaciones',
  Genie: 'Genio',
  Shops: 'Tiendas',
  HowItWorks: 'Cómo funciona',
  RunEvents: 'Eventos',
  CollegiatePickleball: 'Pickleball colegial',
  News: 'Noticias',
  LogIn: 'Entrar',
  SignUp: 'Registrarse',
  decline: 'Rechazar',
  savePublish: 'Guardar y publicar',
  publish: 'Publicar',
  publishing: 'Publicar',
  upload: 'Subir',
  signUpLogin: 'Registrarse o Iniciar sesión',
  January: 'Enero',
  February: 'Febrero',
  March: 'Marzo',
  April: 'Abril',
  May: 'Mayo',
  June: 'Junio',
  July: 'Julio',
  August: 'Agosto',
  September: 'Septiembre',
  October: 'Octubre',
  November: 'Noviembre',
  December: 'Diciembre',
  following: 'Siguiendo',
  followers: 'Seguidores',
  rating: 'Valoración',
  MatchDate: 'Fecha del partido',
  CreatedDate: 'Fecha de creación',
  ModifiedDate: 'Fecha de modificación',
  follow: 'Seguir',
  unFollow: 'Dejar de seguir',
  noFollowing: 'Este jugador aún no sigue a nadie',
  home: 'Inicio',
  removeConfirm: '¿Estás seguro de que quieres eliminar esto?',
  edit: 'Modificar',
  play: 'Jugar',
  invitePlayerSuccess: 'Invitar al éxito del jugador',
  createAMatch: 'Crear un partido',
  marketingAssets: 'Recursos del club',
  settings: 'Configuración',
  compliantText:
    'Al marcar esta casilla, acepta recibir más información sobre nuestras actualizaciones de productos, eventos, noticias y ofertas.',
  communityGuidelines: 'Directrices de la comunidad',
  minorLeaguePickleball: 'Minor League',
  collegiatePickleball: 'Collegiate',
  blog: 'Blog',
  playerName: 'Nombre del jugador',
  addMembers: 'Añadir miembros al grupo',
  verifyEmail: 'Verifica tu Email',
  mustVerify: 'Debe verificar su correo electrónico para acceder a esta función.',
  clickResendLink: 'Haz clic en «reenviar enlace» para recibir un enlace de verificación.',
  changeEmail: '¿Desea cambiar su dirección de correo electrónico?',
  alreadyVerified: 'Ya verificado',
  resendLink: 'Reenviar enlace',
  aLinkWasSent: 'Se ha enviado un enlace a su nuevo correo electrónico.',
  deleteMatchDesc:
    '¿Estás seguro de que deseas eliminar este partido? Una vez eliminado, no podrás restaurarlo y se eliminará de los perfiles de los jugadores y de la página de partidos del club.',
  externalMatchManaged:
    'Este partido se subió en una plataforma externa y debe editarse o eliminarse allí.',
  externalApplication: 'La clasificación de pickleball más precisa delShow age mundo',
  venturedPath: 'Te has desviado del camino.',
  notFollowing: 'Este jugador aún no sigue a nadie',
  noFollower: 'Este jugador aún no tiene seguidores',
  hasVerifiedMatch: 'La jugadora ha verificado el partido',
  matchOwner: 'Dueña del partido',
  firstNamePlaceHolder: 'Ingrese el nombre',
  lastNamePlaceHolder: 'Ingrese el apellido',
  removed: 'eliminé',
  today: 'Hoy',
  yesterday: 'Ayer',
  privacy: 'Privacidad',
  displayAge: 'Mostrar edad',
  hideAge: 'Ocultar edad',
  displayLocation: 'Ubicación de visualización',
  hideLocation: 'Ocultar ubicación',
  doNotTrack: 'No rastrear',
  allowTracking: 'Permitir seguimiento',
  allowTargetedAds: 'Permitir anuncios personalizados',
  disallowTargetedAds: 'No permitir anuncios personalizados',
  subscriptions: 'Suscripciones',
  haveActiveSubscription: 'Tienes una suscripción activa.',
  toManageSubscription: 'Para gestionar tu suscripción, por favor',
  visitThisLinkTo: 'Visita este enlace para',
  subscriptionStatus: 'Estado de Suscripción',
  manageSubscription: 'Administrar suscripción',
  and: 'y',
  phoneVerify:
    'Al introducir mi número de teléfono móvil, acepto recibir mensajes de texto para la verificación de la cuenta y la autenticación de dos factores (2FA). Pueden aplicarse tarifas de mensajes y datos estándar. Estos mensajes se utilizan únicamente para ayudar a proteger mi cuenta y verificar mi identidad y no para fines de marketing',
  phoneOptInRequired:
    'Debe aceptar la opción de recibir mensajes de texto para la verificación de la cuenta y la autenticación de dos factores que se indica arriba.',

  verifyYourPhone: 'Verifica tu teléfono',
  sentCodeTo: 'Hemos enviado un código a {{phone}}',
  sendCodeTo: 'Enviar un código a {{phone}}',
  phoneVerified: 'Número de teléfono verificado',
  youreAllSet: 'Todo listo.',
  sending: 'Enviando...',
  sendCode: 'Enviar código',
  verifying: 'Verificando...',
  resendIn: 'Reenviar en {{s}} segundos',
  resendCode: 'Reenviar código',
  otpDisclaimer: 'Pueden aplicarse tarifas estándar de mensajes.',
  invalidCode: 'Código inválido, inténtalo de nuevo.',
  genericError: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  phoneMissing: 'No hay número de teléfono para verificar.',
  verifyingNumber: 'Verificando número',
  iso: 'ISO',
  changeNumber: 'Cambiar número',
}

export default common
